<template>
    <div class="form-element__container email-container" :id="fullFormIdentifier + '-container'">
        <input
            :id="fullFormIdentifier"
            v-model="email"
            :class="{ 'form-element__input--active': email !== '' }"
            class="form-element__input email__input"
            type="text"
            data-validate="email"
            data-validate-message="Please enter your email address"
            :data-error-target="fullFormIdentifier + '-container'"
            name="email"
            autocomplete="off"
            placeholder="Email *"
            :readonly="readonly"
        />
    </div>
</template>

<script>
    import GenericInput from './GenericInput.vue';
    export default {
        components: {
            GenericInput,
        },
        props: {
            formIdentifier: {
                type: String,
                default: "form",
            },
            readonly:{
                type: Boolean,
                default: false
            }
        },
        emits: ['input'],
        mounted: function(){
            this.$emit('input', this.$store.state.CustomerData.email)
        },
        computed: {
            email: {
                get: function () {
                    return this.$store.state.CustomerData.email;
                },
                set: function (newValue) {
                    this.$store.dispatch("CustomerData/storeCustomerData", { email: newValue });
                    this.$emit('input', newValue)
                },
            },
            fullFormIdentifier() {
                return this.formIdentifier + "-" + this._uid;
            },
        },
    };
</script>